import React from 'react'

const InfluenzaKindsOfFluTesting = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem right-padding6rem pt-md-5 pt-4 pb-md-5 pb-4 bg-img' style={{ backgroundImage:"url('influenza-testing/ULC-Testing-bg-v1.png')"}}>
            <div className='pb-md-4 pb-3 pt-md-3 pt-2'>
                <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                    Distinct Kinds of Flu Testing Chicago
                </div>
                <hr className='hr-style my-md-' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>

            </div>

            <div className='pb-2'>
                <div className='fs-ss-22-2 text-ss-secondary text-montserrat fw-700 ' style={{ letterSpacing:'0.5px'}}>
                    Rapid Influenza Antigen Testing
                </div>
            </div>

            <div className='pb-3'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                The most common type of flu test offered by United Lab Care in Chicago is a diagnostic or rapid influenza antigen test. Although it can provide results in less than half an hour, this quick test is less accurate than other tests for the flu.
                </div>
            </div>

            <div className='pb-2'>
                <div className='fs-ss-22-2 text-ss-secondary text-montserrat fw-700 ' style={{ letterSpacing:'0.5px'}}>
                    Molecular Flu Testing
                </div>
            </div>

            <div className=''>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                A common molecular test is a PCR (polymerase chain reaction). Some molecular tests provide rapid results. However, you will have to wait longer for the results because the most accurate tests necessitate sending a sample of fluid from your mouth or nose to a specialized laboratory. A quick flu test in Chicago can be used to confirm the results with molecular tests.
                </div>
            </div>
        </div>
    </div>
  )
}

export default InfluenzaKindsOfFluTesting